import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import { NumberInput } from '../../../../../components/paymentinput/paymentinput';
import { TransformedItems } from '../../tradeDocumentTypes/CommercialTypes';
import CustomTextField from '../../../../../components/CustomTextInput';

export interface housebillofladingfieldProps {
    id: string | number;
    updateQuoteField: (
        index: number,
        attributeName: keyof TransformedItems,
        attributeValue: TransformedItems[keyof TransformedItems]
    ) => void;
    index: number;
    removeQuoteField: (index: number) => void;
    item: any;
}

const Housebillofladingfield = ({
    id,
    updateQuoteField,
    index,
    removeQuoteField,
    item
}: housebillofladingfieldProps) => {
    return (
        <div className='relative custom-quote-field'>
            <Grid container>
                <Grid item xs={12} md={12} lg={6}>
                    <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1.1rem] lg:pb-2 lg:h-full'>
                        <Grid
                            container
                            spacing={1}
                            sx={{
                                marginTop: '0px'
                            }}
                        >
                            <Grid item xs={12} md={12} lg={6}>
                                <CustomTextField
                                    id={`quote-productCode-${id}`}
                                    label='Product Code'
                                    name='productCode'
                                    onChange={(e) => {
                                        updateQuoteField(
                                            index,
                                            'productCode',
                                            e.target.value
                                        );
                                    }}
                                    value={item?.productCode}
                                />
                            </Grid>

                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 lg:mt-0'>
                                    <CustomTextField
                                        required
                                        id={`quote-desc-${id}`}
                                        label='Description of Goods'
                                        name='desc'
                                        value={item?.desc}
                                        onChange={(e) => {
                                            updateQuoteField(
                                                index,
                                                'desc',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={6}>
                    <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1.1rem] lg:pb-4'>
                        <Grid
                            container
                            spacing={1}
                            sx={{
                                marginTop: '0px'
                            }}
                        >
                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 lg:mt-0'>
                                    <CustomTextField
                                        value={item?.kindOfPackage}
                                        id={`quote-kindOfPackage-${id}`}
                                        label='Package Kind'
                                        name='kindOfPackage'
                                        onChange={(e) => {
                                            updateQuoteField(
                                                index,
                                                'kindOfPackage',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 lg:mt-0'>
                                    <CustomTextField
                                        id={`quote-qtyOfPackage-${id}`}
                                        label='Package Qty'
                                        name='qtyOfPackage'
                                        value={item?.qtyOfPackage}
                                        InputProps={{
                                            inputComponent: NumberInput,
                                            inputProps: {
                                                min: '0',
                                                inputMode: 'numeric',
                                                pattern: '[0-9]*'
                                            }
                                        }}
                                        onChange={(e) => {
                                            updateQuoteField(
                                                index,
                                                'qtyOfPackage',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={12} lg={12}>
                                <div className='mt-4'>
                                    <CustomTextField
                                        id={`quote-chargeable-${id}`}
                                        label='Chargeable'
                                        name='chargeable'
                                        value={item?.chargeable}
                                        onChange={(e) => {
                                            updateQuoteField(
                                                index,
                                                'chargeable',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>

            {index !== 0 && (
                <div
                    className='absolute top-[1rem] cursor-pointer right-[-0.8rem] custom-quote-field-delete w-fit transition-all delay-75'
                    onClick={() => {
                        removeQuoteField(index);
                    }}
                >
                    <DeleteIcon />
                </div>
            )}

            <div className='border border-gray300 border-dashed mt-4 lg:mt-0 lg:border-none' />
        </div>
    );
};

export default Housebillofladingfield;
